export const AI_TUTOR_API = {
  CHAT_STREAM_API: "/v2/chat/stream",
  CONVERSATIONS_API: "/v2/conversations",
  RENAME_CONVERSATION_API: "/v2/conversations/{conversation_id}/title?title={title}",
  CHAT_STREAM_API_ERROR_STRING: "AI chat stream error",
  CONVERSATIONS_API_ERROR_STRING: "AI conversations error",
  SAVE_LEARNING_PLAN_API: "/v2/learning-plans",
  SAVE_LEARNING_PLAN_API_ERROR_STRING: "Save learning plan error",
  LOAD_LEARNING_PLANS_API: "/v2/learning-plans",
  LOAD_LEARNING_PLANS_API_ERROR_STRING: "Load learning plans error",
};

// Learning Plan API Constants
export const LEARNING_PLAN_API = {
  CREATE_LEARNING_PLAN_API: "/v2/learning-plan",
  CREATE_STREAM_LEARNING_PLAN_API: "/v2/learning-plan/stream",
  GET_LEARNING_PLAN_API: "/v2/learning-plan",
  GET_USER_PLANS_API: "/v2/learning-plan/user",
  SAVE_LEARNING_PLAN_API: "/v2/learning-plan/save",
  CREATE_LEARNING_PLAN_ERROR_STRING: "Create learning plan error",
  GET_LEARNING_PLAN_ERROR_STRING: "Get learning plan error",
  GET_USER_PLANS_ERROR_STRING: "Get user learning plans error",
  SAVE_LEARNING_PLAN_ERROR_STRING: "Save learning plan error",
};

// TOPIK API Constants
export const TOPIK_API = {
  GENERATE_QUESTION_API: "/v2/topik/question",
  GET_QUESTION_TYPES_API: "/v2/topik/question-types",
  GET_USER_HISTORY_API: "/v2/topik/user",
  SAVE_QUESTION_API: "/v2/topik/question/save",
  GENERATE_QUESTION_ERROR_STRING: "Generate TOPIK question error",
  GET_QUESTION_TYPES_ERROR_STRING: "Get question types error",
  GET_USER_HISTORY_ERROR_STRING: "Get user question history error",
  SAVE_QUESTION_ERROR_STRING: "Save TOPIK question error",
};

// Vocabulary API Constants
export const VOCAB_API = {
  GENERATE_VOCABULARY_API: "/v2/vocab-expansion",
  GET_VOCABULARY_TYPES_API: "/v2/vocab-expansion",
  GET_USER_HISTORY_API: "/v2/conversations",
  SAVE_VOCABULARY_API: "/v2/vocab-expansion/save",
  GENERATE_VOCABULARY_ERROR_STRING: "Generate vocabulary error",
  GET_VOCABULARY_TYPES_ERROR_STRING: "Get vocabulary types error",
  GET_USER_HISTORY_ERROR_STRING: "Get user vocabulary history error",
  SAVE_VOCABULARY_ERROR_STRING: "Save vocabulary error",
};

// Library API Constants
export const LIBRARY_API = {
  ADD_TO_LIBRARY_API: "/v2/library/toggle",
  GET_USER_LIBRARY_API: "/v2/library/list",
  UPDATE_LIBRARY_METADATA_API: "/v2/library/update",
  ADD_TO_LIBRARY_ERROR_STRING: "Add to library error",
  REMOVE_FROM_LIBRARY_ERROR_STRING: "Remove from library error",
  GET_USER_LIBRARY_ERROR_STRING: "Get user library error",
  UPDATE_LIBRARY_METADATA_ERROR_STRING: "Update library metadata error",
  GET_LIBRARY_STATS_ERROR_STRING: "Get library stats error",
};

// Writing API Constants
export const WRITING_API = {
  GET_TOPIK_WRITING_PROBLEMS_API: "/v2/topik-writing/problems",
  TOPIK_WRITING_PROBLEMS_API_DETAIL: "/v2/topik-writing/problems/start",
  GET_TOPIK_WRITING_PROBLEM_API: "/v2/topik-writing/problems",
  CREATE_TOPIK_WRITING_SUBMISSION_API: "/v2/topik-writing/submissions",
  GET_USER_SUBMISSIONS_API: "/v2/topik-writing/submissions",
  GET_TOPIK_WRITING_SUBMISSION_API: "/v2/topik-writing/submissions",
  UPDATE_TOPIK_WRITING_SUBMISSION_API: "/v2/topik-writing/submissions",
  DELETE_TOPIK_WRITING_SUBMISSION_API: "/v2/topik-writing/submissions",
  EVALUATE_TOPIK_WRITING_SUBMISSION_API: "/v2/topik-writing/submissions",
  GET_LEARNING_MATERIALS_API: "/v2/topik-writing/materials",
  GET_SUBMISSION_FEEDBACK_API: "/v2/topik-writing/submissions",
  GET_TOPIK_WRITING_PROBLEMS_ERROR_STRING: "Get topik writing problems error",
  GET_TOPIK_WRITING_PROBLEM_ERROR_STRING: "Get topik writing problem error",
  CREATE_TOPIK_WRITING_SUBMISSION_ERROR_STRING: "Create topik writing submission error",
  GET_USER_SUBMISSIONS_ERROR_STRING: "Get user submissions error",
  GET_TOPIK_WRITING_SUBMISSION_ERROR_STRING: "Get topik writing submission error",
  UPDATE_TOPIK_WRITING_SUBMISSION_ERROR_STRING: "Update topik writing submission error",
  DELETE_TOPIK_WRITING_SUBMISSION_ERROR_STRING: "Delete topik writing submission error",
  EVALUATE_TOPIK_WRITING_SUBMISSION_ERROR_STRING: "Evaluate topik writing submission error",
  GET_LEARNING_MATERIALS_ERROR_STRING: "Get learning materials error",
  GET_SUBMISSION_FEEDBACK_ERROR_STRING: "Get submission feedback error",
};

// AI Level Test API Constants
export const AI_LEVEL_TEST_API = {
  GET_QUESTIONS_API: "/v2/level-test/questions/random",
  START_ASSESSMENT_API: "/v2/level-test/start",
  SUBMIT_ANSWER_API: "/v2/level-test/assessments/{assessment_id}/answer",
  COMPLETE_ASSESSMENT_API: "/v2/level-test/assessments/{assessment_id}/complete",
  GET_ASSESSMENT_RESULT_API: "/v2/level-test/assessments/{assessment_id}",
  CHECK_USER_IS_TESTED_API: "/v2/users/check",
};
